export const SECTION_TEXT = {
  CUISINES: 'Cuisines',
  DISHES: 'Dishes',
  SHEFS: 'Shefs',
};

export const NO_RESULTS_TEXT = 'Sorry, we can’t find items that match';

export const PRESS_ENTER_TEXT = 'Press enter to see all results';

export const VIEW_RESULTS_TEXT = 'View all results';
